// NZSC-3199 — 외부 API 점검창(external_api_maintenance) CRUD 클라이언트 (Vue2 admin)
// api-admin /api/v1/external-api-maintenance
// - request body: camelCase (provider, startDate, endDate, useYn)
// - response 래퍼: { code:0, message:'success', data }
//   * 목록 data: { items: MaintenanceItem[], totalCount }
//   * 단건 data: MaintenanceItem
// - MaintenanceItem: { maintenanceSeq, provider, startDate, endDate, useYn, createDate, isInMaintenance }
//   날짜는 'YYYY.MM.DD HH:mm:ss' KST 문자열. 입력은 'YYYY-MM-DD HH:mm:ss' 또는 'YYYY-MM-DD'.
// - api 인터셉터(utils/api.js)는 error.response 를 그대로 reject → caller 에서 err.status / err.data
import api from "../../utils/api";

const BASE = "/api/v1/external-api-maintenance";

const state = {
  _items: [],
  _totalCount: 0,
  // NZSC-3494 — 상단 배너용 수집 공지. 평시엔 빈 배열이고, 그때 배너는 렌더되지 않는다.
  _maintenanceNotices: [],
};

const mutations = {
  setExternalApiMaintenanceList(state, { items, totalCount }) {
    state._items = Array.isArray(items) ? [...items] : [];
    state._totalCount = totalCount || 0;
  },
  setExternalMaintenanceNotices(state, items) {
    state._maintenanceNotices = Array.isArray(items) ? [...items] : [];
  },
};

const actions = {
  // provider 미지정 시 전체 조회
  async acExternalApiMaintenanceList({ commit }, { provider } = {}) {
    try {
      const res = await api.get(BASE, {
        params: {
          provider: provider || undefined,
        },
      });
      const data = res.data?.data || {};
      commit("setExternalApiMaintenanceList", {
        items: data.items || [],
        totalCount: data.totalCount || 0,
      });
      return data;
    } catch (err) {
      console.log("acExternalApiMaintenanceList err", err.message || err);
      commit("setExternalApiMaintenanceList", { items: [], totalCount: 0 });
      return null;
    }
  },

  /**
   * NZSC-3494 — 상단 배너용. 수집된 정부사이트 점검 공지 중 진행 중 + D-3 이내.
   * 지평은 시각이 아니라 KST 달력 날짜 기준(NZSC-3512). 판정·필터는 전부 BE 몫이다.
   *
   * 위 목록이 "우리가 건 차단 스위치"라면 이건 "등기소·세움터가 이렇게 공지했다"는 관측이다.
   * 필터(stale·recurring·무중단·종료분 제외)는 BE 가 끝낸 상태로 온다.
   *
   * 실패해도 조용히 빈 배열로 둔다 — 배너는 보조 정보라 로딩 오버레이도 토스트도 띄우지 않는다.
   */
  async acExternalMaintenanceNoticeList({ commit }) {
    try {
      const res = await api.get(`${BASE}/notices/upcoming`);
      const data = res.data?.data || {};
      commit("setExternalMaintenanceNotices", data.items || []);
      return data;
    } catch (err) {
      commit("setExternalMaintenanceNotices", []);
      return null;
    }
  },

  async acExternalApiMaintenanceCreate(_, payload) {
    // payload: { provider, startDate, endDate, useYn }
    const res = await api.post(BASE, payload);
    return res.data?.data;
  },

  async acExternalApiMaintenanceUpdate(_, { seq, payload }) {
    const res = await api.put(`${BASE}/${seq}`, payload);
    return res.data?.data;
  },

  async acExternalApiMaintenanceDelete(_, { seq }) {
    const res = await api.delete(`${BASE}/${seq}`);
    return res.data?.data;
  },

  // 활성 토글 (use_yn)
  async acExternalApiMaintenanceUseYn(_, { seq, useYn }) {
    const res = await api.patch(`${BASE}/${seq}/use-yn`, { useYn });
    return res.data?.data;
  },

  // 즉시 시작 (startDate 를 now 로)
  async acExternalApiMaintenanceStartNow(_, { seq }) {
    const res = await api.patch(`${BASE}/${seq}/start-now`);
    return res.data?.data;
  },

  // 즉시 종료 (endDate 를 now 로)
  async acExternalApiMaintenanceEndNow(_, { seq }) {
    const res = await api.patch(`${BASE}/${seq}/end-now`);
    return res.data?.data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
